import gql from 'graphql-tag'

export const Q_GET_GROUPS = gql`
query ($where:ListWhere) {
  groups (where:$where) {
    id
    name
    code
    currentTeam
    adminInfo
    parentGroupId
    isActive
  }
}`

export const M_ADD_GROUP = gql`mutation ($code:String, $name:String, $currentTeam: String, $adminInfo: JSON, $parentGroupId: Int, $isActive: Boolean) {
  createGroup (code:$code, name:$name, currentTeam:$currentTeam, adminInfo:$adminInfo, parentGroupId:$parentGroupId, isActive:$isActive)
  {
    id
    code
    name
    currentTeam
    adminInfo
    parentGroupId
    isActive
  }
}`

export const M_UPDATE_GROUP = gql`mutation ($id:Int!, $code:String, $name:String, $currentTeam: String, $adminInfo: JSON, $parentGroupId: Int, $isActive: Boolean) {
  updateGroup (id:$id, code:$code, name:$name, currentTeam:$currentTeam, adminInfo:$adminInfo, parentGroupId:$parentGroupId, isActive:$isActive)
  {
    id
    code
    name
    currentTeam
    adminInfo
    parentGroupId
    isActive
  }
}`

export const M_CREATE_MANY_GROUPS = gql`mutation($records:[GroupInput]!) {
  createGroups(records:$records) {
    id
    code
    name
    currentTeam
    adminInfo
    parentGroupId
    isActive
  }
}`

export const M_DELETE_GROUP = gql`mutation($where:ListWhere!) {
  deleteGroup(where:$where)
}`
